import React from 'react';
import { useState } from 'react';
import { Box, Button, Grid, Typography , Link } from '@mui/material';
import { Howl } from 'howler';
import sound2 from './rsb/56k.mp3';
import sound3 from './rsb/callen.mp3';
import sound4 from './rsb/callen2.mp3';
import sound5 from './rsb/chris.mp3';
import sound6 from './rsb/devil.mp3';
import sound7 from './rsb/hentai.mp3';
import sound8 from './rsb/hila.mp3';
import sound9 from './rsb/hila2.mp3';
import sound10 from './rsb/homie.mp3';
import sound11 from './rsb/israel.mp3';
import sound12 from './rsb/logan.mp3';
import sound13 from './rsb/logan2.mp3';
import sound14 from './rsb/logan3.mp3';
import sound15 from './rsb/mike.mp3';
import sound16 from './rsb/mike2.mp3';
import sound17 from './rsb/mike3.mp3';
import sound18 from './rsb/nasty.mp3';
import sound19 from './rsb/proud boys.mp3';
import sound20 from './rsb/schulz.mp3';
import sound21 from './rsb/schulz2.mp3';
import sound22 from './rsb/schulz3.mp3';
import sound23 from './rsb/schulz4.mp3';
import sound24 from './rsb/schulz5.mp3';
import sound25 from './rsb/soul.mp3';
import sound26 from './rsb/spider.mp3';
import sound27 from './rsb/steveo.mp3';
import sound28 from './rsb/steveo2.mp3';
import sound29 from './rsb/suicide.mp3';

const Soundboard = () => {



  const sounds = [
    { label: '56k', id: '56k', file: sound2 },
    // { label: 'bloop', id: 'sound3', file: sound3 },
    // { label: 'chris about to cry', id: 'sound4', file: sound4 },
    { label: 'cheers', id: 'cheers', file: sound5 },
    { label: "devil", id: 'devil', file: sound6 },
    { label: 'hentai', id: 'hentai', file: sound7 },
    // { label: 'jewish insult', id: 'sound8', file: sound8 },
    // { label: 'whiny little bitch', id: 'sound9', file: sound9 },
    { label: 'homie', id: 'homie', file: sound10 },
    { label: 'israel', id: 'israel', file: sound11 },
    // { label: 'police', id: 'sound12', file: sound12 },
    // { label: 'prison', id: 'sound13', file: sound13 },
    { label: 'nasty', id: 'nasty', file: sound18 },
    { label: 'geeks', id: 'star wars', file: sound19 },
    { label: 'accused', id: 'rape', file: sound3 },
    { label: 'soul', id: 'soul', file: sound25 },
    { label: 'spider', id: 'spider', file: sound26 },
    { label: 'suicide', id: 'suicide', file: sound29 },
  ];

  const sounds2 = [
    { label: 'man tears', id: 'man tears', file: sound4 },
    { label: 'pizza mama', id: 'pizza mama', file: sound8 },
    { label: 'hell raiser', id: 'hell raiser', file: sound9 },
    { label: 'new yorker', id: 'new yorker', file: sound12 },
    { label: 'i got a nina', id: 'nina', file: sound13 },
    { label: 'picked on', id: 'bullied', file: sound14 },
    { label: 'sexy guy', id: 'sexy guy', file: sound15 },
    { label: 'east coast guys', id: 'east coast guys', file: sound16 },
    { label: 'opinions of sheep', id: 'sheep', file: sound17 },
    { label: 'turn your phone sideways', id: '8', file: sound22 },
    { label: 'hero', id: 'hero', file: sound20 },
    { label: 'fuck netflix', id: 'netflix', file: sound21 },
    { label: 'heavyweight champion of the world', id: 'snd8', file: sound23 },
    { label: 'infamous special', id: 'infamous', file: sound24 },
    { label: 'manscaped', id: 'manscaped', file: sound27 },
  ]

  const playSound = (file) => {
    const sound = new Howl({
      src: [file],
    });
    sound.play();
  };

  const [board, setBoard] = useState(sounds)
  const [bar, setBar] = useState("black")
  const [fools, setFools] = useState('grey')

  const boardChange = (change) =>{
    if(change=="redbar"){
      setBoard(sounds)
      setBar('black')
      setFools('grey')
    } 
    if(change=="fools"){
      setBoard(sounds2)
      setFools('black')
      setBar('grey')
    }
  }

  return (
    <Box sx={{ p: 4, fontFamily: 'Oswald, sans-serif' }}>
      <Grid container spacing={2} sx={{ columnGap: 4 }}>
        <Typography 
          variant="h4" 
          gutterBottom 
          sx={{ textAlign: 'center',
                color:bar,
                cursor:'pointer', 
                fontFamily: 'Oswald, sans-serif',
                transition:"ease-in 400ms",
                '&:hover': { color: 'red' },
              }}
            onClick={() => boardChange("redbar")}
        >
          REDBAR
        </Typography>
        <Typography 
          variant="h4" 
          gutterBottom 
          sx={{ textAlign: 'center',
            color:fools,
            cursor:'pointer', 
            fontFamily: 'Oswald, sans-serif',
            transition:"ease-in 400ms",
            '&:hover': { color: 'red' },
          }}
          onClick={() => boardChange("fools")}
        >
          FOOLS
        </Typography>
      </Grid>
      
      <Grid container spacing={2} sx={{ rowGap: 4 }} data={board}>
        {board.map((sound) => (
          <Grid item xs={12} sm={6} md={4} key={sound.id} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              variant="contained"
              fullWidth
              sx={{ 
                height: '150px', 
                fontWeight: 'bold', 
                color: 'white', 
                backgroundColor: 'black', 
                transition:"ease-in 400ms",
                '&:hover': { backgroundColor: '#333' },
                fontFamily: 'Oswald, sans-serif' 
              }}
              onClick={() => playSound(sound.file)}
            >
              {sound.label}
            </Button>
          </Grid>
        ))}
      </Grid>
      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Typography variant="body1" sx={{ fontFamily: 'Oswald, sans-serif' }}>
          
          <Link href="https://www.youtube.com/playlist?list=PL-JwJjwsNXVM7A6BPMMtaEI8aQojgx6kM" target="_blank" rel="noopener" sx={{ ml: 1, fontWeight: 'bold', textDecoration: 'none' }}>
            check out my redbar clips
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};


alert("sounds are downloaded locally when their button is pressed, causing some delay for the first press. for best performance, press each button once to load all the sounds before use")

export default Soundboard;
